const textEncoder = new TextEncoder();

const BASE64_PADDING_REGEX = /=+$/u;
const BASE64_PLUS_REGEX = /\+/gu;
const BASE64_SLASH_REGEX = /\//gu;

/**
 * Encodes a UTF-8 string using a browser- and Node-safe base64url alphabet.
 */
const getBase64Url = (value: string) => {
  let binary = '';
  for (const byte of textEncoder.encode(value)) binary += String.fromCharCode(byte);

  return btoa(binary)
    .replace(BASE64_PLUS_REGEX, '-')
    .replace(BASE64_SLASH_REGEX, '_')
    .replace(BASE64_PADDING_REGEX, '');
};

/**
 * Converts logical cache keys into Pusher-safe transport channel names.
 */
export const getPusherChannelName = (logicalChannelName: string) => `cache-${getBase64Url(logicalChannelName)}`;
